import { reactive } from 'vue';

export const eventBus = reactive({
  events: {} as any,
  emit(event: any, data: any) {
    if (this.events[event]) {
      this.events[event].forEach((callback: any) => callback(data));
    }
  },
  on(event: any, callback: any) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  },
  off(event: string, callback: Function) {
    if (this.events[event]) {
      this.events[event] = this.events[event].filter((cb:any) => cb !== callback);
    }
  }
});